<div class="flex flex-col h-full w-full justify-start items-start gap-6 font-medium bg-[#FFF]">
  <app-quality-stepper #stepper [nextStepAllowed]="true" [selectedStep]="0" class="w-full"></app-quality-stepper>

  <div class="flex flex-col w-full flex-1 min-h-0 justify-start items-start gap-6 px-6 overflow-hidden">
      <app-overview-reports (download)="downloadReport()"
                            [activateDownload]="!loading"
                            [checkerName]="(qualityCheck?.checker?.firstName ?? '') + ' ' + (qualityCheck?.checker?.lastName ?? '')"
                           [completedValue]="statusSummary.completed"
                            [date]="$safeNavigationMigration(qualityCheck?.checkDate)"
                           [errorValue]="statusSummary.error"
                           [fileDeactivated]="true"
                            [info2]="qualityCheck?.qualityCheckProjectFiles?.length ?? 0"
                            [loading]="loading"
                           [warningValue]="statusSummary.warning"
                            [rules]="checkedRuleCount.toString()"
                           checkType="QUALITY"
                           info1="All-Right Check">
      </app-overview-reports>

    @if (!loading && qualityCheck.completed && numberOfCheckedFiles <= 1) {
      <div class="flex flex-col w-full h-full justify-center items-center gap-12 overflow-hidden">
        <fa-icon [icon]="faBicErrorCloud" class="text-[144px] text-gray-300"></fa-icon>
        <div class="w-[514px] text-center">
          Für diese Prüfung wurde nur <span class="font-semibold underline">eine Datei</span> ausgewählt.
          Der Konformitäts-Check ist ein Vergleich für den
          <span class="font-semibold underline">mindestens zwei Dateien</span> ausgewählt bzw. geprüft werden müssen.
        </div>
      </div>
    }

    @if (loading) {
      <div class="h-full min-h-0 overflow-hidden overflow-y-auto border border-gray-200 rounded-md w-full">
        <div class="flex flex-col flex-1 h-full justify-center items-center py-16">
          <div class="flex flex-row items-center gap-2">
            <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
            <span class="text-sm font-medium text-gray-500">Ergebnisse werden geladen...</span>
          </div>
        </div>
      </div>
    }

    @if (!loading && qualityCheck.completed && numberOfCheckedFiles > 1) {
      <div class="flex flex-col w-full flex-1 min-h-0 justify-start items-start gap-4 overflow-hidden">
        <cdk-table [dataSource]="dataSource" class="w-full rounded-md overflow-y-auto border border-gray-200 border-b-0"
                   multiTemplateDataRows>
          <!--        Original  Bauteil, Informationsanforderung w16% und Ergebnis w13%  und Status w7%-->
          <ng-container cdkColumnDef="component">
            <cdk-header-cell *cdkHeaderCellDef
                             class="flex flex-row h-full w-[16%] justify-start items-center font-medium py-4 pl-7">
              BAUTEIL
            </cdk-header-cell>
            <cdk-cell *cdkCellDef="let element"
                      class=" flex flex-row h-full w-[16%] justify-start items-start pl-7"> {{ element.component }}
            </cdk-cell>
          </ng-container>
          <ng-container cdkColumnDef="requiredInformation">
            <cdk-header-cell *cdkHeaderCellDef
                             class="flex flex-row h-full w-[16%] justify-start items-center font-medium py-4 pl-7">
              ATTRIBUT
            </cdk-header-cell>
            <cdk-cell *cdkCellDef="let element"
                      class=" flex flex-row h-full w-[16%] justify-start items-start pl-7"> {{ element.requiredInformation }}
            </cdk-cell>
          </ng-container>
          <ng-container cdkColumnDef="state">
            <cdk-header-cell *cdkHeaderCellDef
                             class=" flex flex-row w-[7%] h-full justify-center items-center font-medium py-4">
              PRÜFSTATUS
            </cdk-header-cell>
            <cdk-cell *cdkCellDef="let element" class="flex flex-row justify-center items-center w-[7%] h-full">
              @switch (getStatus(element)) {
                @case ('success') {
                  <fa-icon [icon]="faCircleCheck" class="text-green text-base"></fa-icon>
                }
                @case ('warning') {
                  <fa-icon [icon]="faCircleExclamation" class="text-yellow text-base"></fa-icon>
                }
                @case ('error') {
                  <fa-icon [icon]="faCircleXmark" class="text-red text-base"></fa-icon>
                }
              }
            </cdk-cell>
          </ng-container>
          <ng-container cdkColumnDef="result">
            <cdk-header-cell *cdkHeaderCellDef
                             class=" flex flex-row h-full w-[18%] justify-start items-center font-medium py-4">
              ERGEBNIS
            </cdk-header-cell>
            <cdk-cell *cdkCellDef="let element"
                      class=" flex flex-row h-full w-[18%] justify-start items-center">
              @switch (getStatus(element)) {
                @case ('success') {
                  <bic-badge type="success">{{ getResponse(element) }}</bic-badge>
                }
                @case ('warning') {
                  <bic-badge type="warning">{{ getResponse(element) }}</bic-badge>
                }
                @case ('error') {
                  <bic-badge type="error">{{ getResponse(element) }}</bic-badge>
                }
              }
            </cdk-cell>
          </ng-container>
          <ng-container cdkColumnDef="LV">
            <cdk-header-cell *cdkHeaderCellDef
                             [class]="'flex flex-row h-min justify-center items-center w-[' + widthString + '%] font-medium py-2'">
              <bic-button [bicDropdownTrigger]="lvDropdown" buttonType="white">
                  {{ selectedLVFile ? filesByExtractionIds.get(selectedLVFile).name : 'Leistungsverzeichnis' }}
                <fa-icon [icon]="faChevronDown" iconRight></fa-icon>
              </bic-button>

              <bic-dropdown #lvDropdown [dropdownPlacement]="'bottom-start'">
                @for (file of filteredLVDocs; track file) {
                  <bic-dropdown-element (click)="onLVFileChange(file)">{{ filesByExtractionIds.get(file).name }}
                  </bic-dropdown-element>
                }
              </bic-dropdown>
            </cdk-header-cell>
            <cdk-cell *cdkCellDef="let row"
                      [class]="'flex flex-row h-full justify-center items-center w-[' + widthString + '%]'"
                      [tooltip]="getValues(selectedLVFile, row.requiredInformation, row.response) == '-' ? 'Nicht erforderlich' : undefined">
              {{ getValues(selectedLVFile, row.requiredInformation, row.response) }}
            </cdk-cell>
          </ng-container>
          <ng-container cdkColumnDef="Room">
            <cdk-header-cell *cdkHeaderCellDef
                             [class]="'flex flex-row h-full justify-center items-center w-[' + widthString + '%] font-medium py-2'">
              <bic-button [bicDropdownTrigger]="rbDropdown" buttonType="white">
                  {{ selectedRoomFile ? filesByExtractionIds.get(selectedRoomFile).name : 'Raumbuch' }}
                <fa-icon [icon]="faChevronDown"></fa-icon>
              </bic-button>

              <bic-dropdown #rbDropdown [dropdownPlacement]="'bottom-start'">
                @for (file of filteredRoomDocs; track file) {
                  <bic-dropdown-element (click)="onRoomFileChange(file)">{{ filesByExtractionIds.get(file).name }}
                  </bic-dropdown-element>
                }
              </bic-dropdown>
            </cdk-header-cell>
            <cdk-cell *cdkCellDef="let row"
                      [class]="'flex flex-row h-full justify-center items-center  w-[' + widthString + '%] '"
                      [tooltip]="getValues(selectedLVFile, row.requiredInformation, row.response) == '-' ? 'Nicht erforderlich' : undefined">
              {{ getValues(selectedRoomFile, row.requiredInformation, row.response) }}
            </cdk-cell>
          </ng-container>
          <ng-container cdkColumnDef="ifc">
            <cdk-header-cell *cdkHeaderCellDef
                             [class]="'flex flex-row h-full justify-center items-center w-[' + widthString + '%] font-medium py-2'">
              <bic-button [bicDropdownTrigger]="ifcDropdown" buttonType="white">
                  {{ selectedIfcFile ? filesByExtractionIds.get(selectedIfcFile).name : 'IFC_Modell' }}
                <fa-icon [icon]="faChevronDown" iconRight></fa-icon>
              </bic-button>

              <bic-dropdown #ifcDropdown [dropdownPlacement]="'bottom-start'">
                @for (file of filteredIfcDocs; track file) {
                  <bic-dropdown-element (click)="onIfcFileChange(file)">{{ filesByExtractionIds.get(file).name }}
                  </bic-dropdown-element>
                }
              </bic-dropdown>
            </cdk-header-cell>
            <cdk-cell *cdkCellDef="let row"
                      [class]="'flex flex-row h-full justify-center items-center  w-[' + widthString + '%]'"
                      [tooltip]="getValues(selectedLVFile, row.requiredInformation, row.response) == '-' ? 'Nicht erforderlich' : undefined">
              {{ getValues(selectedIfcFile, row.requiredInformation, row.response) }}
            </cdk-cell>
          </ng-container>
          <ng-container cdkColumnDef="task">
            <cdk-header-cell *cdkHeaderCellDef
                             class=" flex flex-row h-full w-[2%] justify-center items-center  font-medium py-4"></cdk-header-cell>
            <cdk-cell *cdkCellDef="let element" class="flex flex-row justify-center items-center h-full w-[2%]">
              <fa-icon (click)="createTask(element); $event.stopPropagation()" [icon]="faClipboardCheck"
                       [tooltip]="'Aufgabe erstellen'"
                       class="w-10 hidden-button text-base"></fa-icon>
            </cdk-cell>
          </ng-container>
          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <cdk-cell *cdkCellDef="let element" [attr.colspan]="displayedColumns.length">
              <div [@detailExpand]="expandedElements.includes(element) ? 'expanded' : 'collapsed'"
                   class="flex overflow-hidden w-full">
                <cdk-table [dataSource]="selectedDataSources.get(element)!" class="w-full">
                  <ng-container cdkColumnDef="LV">
                    <cdk-cell *cdkCellDef="let element"
                              [class]="' flex flex-row justify-center items-center  w-[' + widthString + '%]  h-full'">
                      @if (element.lv.size > 0 && element.lv.get(selectedLVFile)) {
                        {{ element.name }}
                      } @else {
                        {{ " -" }}
                      }
                    </cdk-cell>
                  </ng-container>
                  <ng-container cdkColumnDef="Room">
                    <cdk-cell *cdkCellDef="let element"
                              [class]="'flex flex-row justify-center items-center text-center  w-[' + widthString + '%]  h-full'">
                      @if (element.rb.size > 0 && element.rb.get(selectedRoomFile)) {
                        {{ element.name }}
                      } @else {
                        {{ " -" }}
                      }
                    </cdk-cell>
                  </ng-container>
                  <!--   <div class="w-[54%] w-[27%] w-[18%] w-[22%] w-[14%]  w-[44%]"></div>>-->
                  <ng-container cdkColumnDef="ifc">
                    <cdk-cell *cdkCellDef="let element"
                              [class]="'flex flex-row justify-center items-center text-center w-[' + widthString + '%]  h-full'">
                      @if (element.ifc.size > 0 && element.ifc.get(selectedIfcFile)) {
                        {{ element.name }}
                      } @else {
                        {{ " -" }}
                      }
                    </cdk-cell>
                  </ng-container>
                  <ng-container cdkColumnDef="dummy">
                    <cdk-cell *cdkCellDef="let element"
                              class="flex flex-row justify-center items-center m-1 h-full w-[57%]"></cdk-cell>
                  </ng-container>
                  <ng-container cdkColumnDef="task">
                    <cdk-cell *cdkCellDef="let element"
                              class="flex flex-row justify-center items-center m-1 h-full w-[2%]"></cdk-cell>
                  </ng-container>
                  <cdk-row *cdkRowDef="let row; columns: displayedSubColumns;"
                           class="flex flex-row justify-start items-center w-full text-sm border-b border-b-gray-200 py-2"></cdk-row>
                </cdk-table>
              </div>
            </cdk-cell>
          </ng-container>
          <cdk-header-row *cdkHeaderRowDef="displayedColumns sticky: true;"
                          class="flex flex-row justify-start items-center w-full border-b border-gray-200 bg-gray-50 text-gray-500 text-xs text-semibold">
          </cdk-header-row>
          <cdk-row (click)="selectElement(row)"
                   *cdkRowDef="let row; columns: displayedColumns;"
                   [class]="expandedElements.includes(row) ? 'flex flex-row justify-start items-center w-full border-b border-b-gray-200 hover:bg-gray-100 py-4 hover:cursor-pointer font-medium rounded text-sm' :'flex flex-row justify-center items-center w-full border-b border-b-gray-200 hover:bg-gray-100 py-4 hover:cursor-pointer text-sm'">
          </cdk-row>
          <cdk-row *cdkRowDef="let row; columns: ['expandedDetail']"></cdk-row>
        </cdk-table>
      </div>
    }
    <div class="flex flex-row w-full justify-center items-center pb-4">
      <bic-button (click)="stepper.changeStep(1)">
        All-Right Check
        <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
      </bic-button>
    </div>
  </div>
</div>
